import React, { Component } from 'react';
import firebase from '../helpers/firebase';
import { ThemeProvider } from '@material-ui/core/styles';
import styles from './Post.module.css';
import { Helmet } from 'react-helmet';
import NetworkToolbar from './NetworkToolbar';
import { darkTheme } from './darkTheme';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

export default class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {
      post_description: '',
      zip_code: '',
      image: '',
      post_title: '',
      email: '',
      date: null,
      name: '',
      type: '',
      searchValue: '',
      bool: 'Copy Email',
    };
  }

  async componentDidMount(): void {
    let url = window.location.href.split('/');
    let articleId = url[url.length - 1];
    const postDocSnapshot = await firebase
      .firestore()
      .collection('network')
      .doc('posts')
      .collection('posts')
      .doc(articleId)
      .get();

    let post_description = postDocSnapshot.get('post_description');
    let zip_code = postDocSnapshot.get('zip_code');
    let image = postDocSnapshot.get('image');
    let name = postDocSnapshot.get('name');
    let email = postDocSnapshot.get('email');
    let date = postDocSnapshot.get('date');
    let post_title = postDocSnapshot.get('post_title');
    let type = postDocSnapshot.get('type');

    this.setState({
      post_description,
      zip_code,
      image,
      name,
      email,
      date,
      post_title,
      type,
    });
  }

  checkEnter = (event) => {
    if (event.keyCode === 13) {
      localStorage.setItem('searchValue', this.state.searchValue);
      window.location.href = 'https://de-waste.com/network';
      // window.location.href = "http://localhost:3000/network";
    }
  };

  handleChangeSearchValue = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  loadNewPostPage = () => {
    window.location.href = 'https://de-waste.com/network/newPost';
  };

  render() {
    let imageUrl =
      'https://firebasestorage.googleapis.com/v0/b/dewaste.appspot.com/o/networkImages%2F' +
      this.state.image +
      '?alt=media';
    return (
      <ThemeProvider theme={darkTheme}>
        <div>
          <Helmet>
            <meta
              name="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others"
            />

            <meta
              itemProp="name"
              content="DeWaste Network | Connecting food producers and buyers to reduce food waste"
            />
            <meta
              itemProp="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others in their proximity and trade in these food items so they don't go to waste."
            />
            <meta
              itemProp="image"
              content="https://de-waste.com/network_logo.png"
            />

            <meta
              property="og:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="DeWaste Network" />
            <meta
              property="og:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />
            <meta property="og:site_name" content="DeWaste" />
            <meta property="og:url" content="https://de-waste.com/network" />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta name="twitter:title" content="DeWaste Network" />
            <meta
              name="twitter:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />

            <title>
              DeWaste Network | Connecting food producers and buyers
            </title>
          </Helmet>

          <NetworkToolbar
            handleChangeSearchValue={this.handleChangeSearchValue}
            searchValue={this.state.searchValue}
            checkEnter={this.checkEnter}
          />

          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />

          <div className={styles.containerDiv}>
            <h1 className={styles.mainText}>{this.state.post_title}</h1>
            <hr className={styles.hr} />

            <div className={styles.networkImgDiv}>
              <img src={imageUrl} alt={''} className={styles.networkImg} />
            </div>

            <div className={styles.formDiv}>
              <form noValidate autoComplete="off">
                <TextField
                  id="filled-read-only-input"
                  label="Listed by"
                  value={this.state.name}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  className={styles.formField}
                />
                <br />
                <br />
                <TextField
                  id="filled-read-only-input"
                  label="Date"
                  value={
                    this.state.date !== null
                      ? this.state.date.toDate().getMonth() +
                        1 +
                        '/' +
                        this.state.date.toDate().getDate() +
                        '/' +
                        this.state.date.toDate().getFullYear()
                      : ''
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  className={styles.formField}
                />
                <br />
                <br />
                <TextField
                  id="filled-read-only-input"
                  label="ZIP code"
                  value={this.state.zip_code}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  className={styles.formField}
                />
                <br />
                <br />
                <TextField
                  id="filled-read-only-input"
                  label="Description"
                  value={this.state.post_description}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  className={styles.formField}
                />
                <br />
                <br />
                <TextField
                  id="filled-read-only-input"
                  label="Email"
                  value={this.state.email}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  className={styles.formField}
                  onClick={() => {
                    navigator.clipboard.writeText(this.state.email);
                  }}
                />
                <br />
                <br />
                <Button
                  onClick={() => {
                    this.setState({ bool: 'Copied!' });
                    navigator.clipboard.writeText(this.state.email);
                  }}
                  variant={'contained'}
                  color="primary"
                  className={styles.copyButton}
                >
                  {this.state.bool}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}
